import { render } from "./TableProject.vue?vue&type=template&id=09b5cb72&scoped=true"
import script from "./TableProject.vue?vue&type=script&lang=js"
export * from "./TableProject.vue?vue&type=script&lang=js"

import "./TableProject.vue?vue&type=style&index=0&id=09b5cb72&lang=scss&scoped=true"

import exportComponent from "/Users/elodie/Desktop/Dev/portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09b5cb72"]])

export default __exports__